/* Heritage & Co. product gallery autoplay (21 Oct 2026).
   Replaces hco-gallery-rotator.js on the carousel gallery: the product photos
   advance every 3 seconds on desktop and mobile, loop back to the first, and
   pause while the mouse is over the photo or its thumbnails. Respects
   prefers-reduced-motion and skips the zoom dialog. */
(function () {
  if (window.__hcoGalleryAutoplay) return;
  window.__hcoGalleryAutoplay = true;
  var SECONDS = 3;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(gallery) {
    if (reduce || gallery.closest('dialog')) return;
    var ss = gallery.querySelector('slideshow-component');
    if (!ss || ss.getAttribute('data-hco-auto')) return;
    if (ss.querySelectorAll('slideshow-slide').length < 2) return;
    ss.setAttribute('data-hco-auto', '1');
    ss.setAttribute('infinite', '');
    ss.setAttribute('autoplay', String(SECONDS));

    var hovering = false;
    gallery.addEventListener('mouseenter', function () {
      hovering = true;
      if (typeof ss.suspend === 'function') ss.suspend();
    });
    gallery.addEventListener('mouseleave', function () {
      hovering = false;
      start();
    });

    function start() {
      if (hovering || !ss.isConnected) return;
      if (typeof ss.suspend === 'function') ss.suspend();
      ss.removeAttribute('paused');
      if (typeof ss.play === 'function') ss.play(SECONDS * 1000);
    }
    customElements.whenDefined('slideshow-component').then(function () {
      setTimeout(start, 50);
    });
  }

  function scan() {
    var galleries = document.querySelectorAll('media-gallery');
    for (var i = 0; i < galleries.length; i++) init(galleries[i]);
  }

  function boot() {
    scan();
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; scan(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
